import React, { useRef, useEffect, useState } from 'react';

const LikeButton = ({ likedCount, onLikeChange }) => {
  const [liked, setLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(likedCount || 0);
  const [animate, setAnimate] = useState(false);

  const handleClick = () => {
    let updatedCount = likeCount;
    if (liked) {
      updatedCount = likeCount - 1;
      setLiked(false);
    } else {
      updatedCount = likeCount + 1;
      setLiked(true);
      setAnimate(true);
      setTimeout(() => setAnimate(false), 500);
    }
    setLikeCount(updatedCount);

    // 🔁 Notify parent of updated count
    if (onLikeChange) {
      onLikeChange(updatedCount);
    }
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        {animate && (
          <span style={{
            position: 'absolute',
            top: '-10px',
            left: '50%',
            transform: 'translateX(-50%)',
            fontSize: '16px',
            opacity: 0,
            animation: 'sparkle 0.5s ease-out',
            pointerEvents: 'none',
          }}>✨</span>
        )}

        <button
          onClick={handleClick}
          style={{
            padding: '4px 10px',
            fontSize: '12px',
            cursor: 'pointer',
            backgroundColor: '#f9f9f9',
            color: liked ? 'white' : 'black',
            border: '1px solid #ddd',
            borderRadius: '4px',
            position: 'relative',
            transition: 'transform 0.2s ease',
            transform: liked ? 'scale(1.1)' : 'scale(1)',
          }}
        >
          {'❤️'}
        </button>

        {likeCount > 0 && (
          <span style={{
            position: 'absolute',
            top: '-6px',
            right: '-6px',
            backgroundColor: '#ea1c5a',
            color: 'white',
            borderRadius: '50%',
            padding: likeCount >= 10 ? '9px 1px' : '3px 6px',
            fontSize: likeCount >= 10 ? '9.2px' : '9.2px',
            fontWeight: '800',
            lineHeight: '1',
            width: likeCount >= 10 ? '17px' : '16px',
            height: likeCount >= 10 ? '17px' : '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>{likeCount}</span>
        )}
      </div>

      <style>{`
        @keyframes sparkle {
          0% { opacity: 0; transform: translateX(-50%) translateY(0px) scale(0.8); }
          50% { opacity: 1; transform: translateX(-50%) translateY(-10px) scale(1.2); }
          100% { opacity: 0; transform: translateX(-50%) translateY(-20px) scale(0.8); }
        }
      `}</style>
    </div>
  );
};

export default LikeButton;